module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "box-text centered"
  }, [_c('div', {
    staticClass: "box-text-btn"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-fill margin-bottom-10",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#subscribe"
    }
  }, [_vm._v("COMENZÁ AHORA")]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn-link deco-dotted",
    attrs: {
      "to": "/suscripcion"
    }
  }, [_vm._v("¿Querés pedir diariamente?")])], 1)])])])]), _vm._v(" "), _c('modal-suscribe'), _vm._v(" "), _c('modal-partner')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "banner-sec bg bg-4"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bg-content"
  }, [_c('h1', {
    staticClass: "size-40 regular"
  }, [_vm._v("Andalepide on-demand")]), _vm._v(" "), _c('p', {
    staticClass: "size-20"
  }, [_vm._v("Las mejores comidas para tu próxima reunión o evento empresarial.")]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn"
  }, [_c('a', {
    staticClass: "btn btn-hg btn-primary btn-fill",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#subscribe"
    }
  }, [_vm._v("COMENZAR")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('img', {
    staticClass: "fe-4",
    attrs: {
      "src": "/images/backgrounds/bg-sandwich2.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 pull-right"
  }, [_c('div', {
    staticClass: "box-text"
  }, [_c('h1', {
    staticClass: "lato size-32 sm-centered"
  }, [_vm._v("Convertí la oficina en un lugar de encuentros y buenos momentos")]), _vm._v(" "), _c('p', {
    staticClass: "size-16 margin-bottom-40 sm-centered"
  }, [_vm._v("Si tenés una reunión, almuerzo en equipo o cumpleaños, andalepide te acerca un menú variado para tu evento.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-text icon-aside"
  }, [_c('p', {
    staticClass: "size-16"
  }, [_c('i', {
    staticClass: "icon-step icon-lunch icon-x5 icon-color-grey"
  }), _vm._v(" "), _c('span', {
    staticClass: "semibold"
  }, [_vm._v("Reuniones de almuerzo")]), _c('br'), _vm._v("Disfrutá con tus compañeros de un buen almuerzo, como en casa.")]), _vm._v(" "), _c('p', {
    staticClass: "size-16"
  }, [_c('i', {
    staticClass: "icon-step icon-muffin icon-x5 icon-color-grey"
  }), _vm._v(" "), _c('span', {
    staticClass: "semibold"
  }, [_vm._v("Cumpleaños y aniversarios")]), _c('br'), _vm._v("Personalizá tu cumpleaños con nuestras comidas."), _c('br'), _vm._v("Cada uno elige su menú y disfrutan juntos de un delicioso almuerzo. ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section grey3 nopad-top-sm"
  }, [_c('div', {
    staticClass: "float-element fe-7"
  }), _vm._v(" "), _c('div', {
    staticClass: "visible-xs visible-sm img-section"
  }, [_c('img', {
    attrs: {
      "src": "/images/backgrounds/bg5.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "box-text"
  }, [_c('h1', {
    staticClass: "lato size-34 sm-centered"
  }, [_vm._v("¿Cómo funciona nuestro on-demand?")])]), _vm._v(" "), _c('div', {
    staticClass: "box-ondemand"
  }, [_c('p', {
    staticClass: "element-1 size-16"
  }, [_vm._v("Crea una orden grupal y agrega a todos los invitados de la reunión/evento. Cada uno podrá elegir el plato que más le guste, de esta manera cada uno almuerza lo que quiere. ")]), _vm._v(" "), _c('i', {
    staticClass: "element-4 icon-list icon-x8 icon-color-brown"
  }), _vm._v(" "), _c('i', {
    staticClass: "element-5 icon-truck icon-x8 icon-color-brown"
  }), _vm._v(" "), _c('span', {
    staticClass: "element-6"
  }), _vm._v(" "), _c('span', {
    staticClass: "element-7"
  }), _vm._v(" "), _c('p', {
    staticClass: "element-2 size-16"
  }, [_vm._v("Nosotros nos encargamos del resto, todos los platos llegan juntos y personalizados. ")]), _vm._v(" "), _c('a', {
    staticClass: "element-3 btn btn-outline btn-outline-grey",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#subscribe"
    }
  }, [_vm._v("MAS INFO")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-text"
  }, [_c('h1', {
    staticClass: "lato size-34"
  }, [_vm._v("Hacé tu pedido hoy")]), _vm._v(" "), _c('p', {
    staticClass: "size-16 hidden-br  -10 durationx050"
  }, [_vm._v("Andalepide trae las mejores comidas a su empresa. Suscribite a nuestro programa "), _c('br'), _vm._v("de comidas en Córdoba Capital. Próximamente más ciudades.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-186aa13a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/static/OnDemand.vue
// module id = 1112
// module chunks = 5